<template>
    <!-- 尾部移动导航栏 -->
    <div class="footer-nav">
        <div class="footer-nav_part1">
            <div class="nav_part1-contact">
                <div class="nav-title">联系我们</div>
                <div class="nav-list">
                    <p class="nav-list_item">
                       <img :src="locationIcon" />
                       <span>中国北京市西城区红莲南路57号中国文化大厦东门9层</span>
                    </p>
                    <p class="nav-list_item">
                        <img :src="phoneIcon" />
                        <span>010-65251329.65289831.65599550</span>
                    </p>
                    <!-- <p class="nav-list_item">
                        <img :src="czjIcon" />
                        <span>010-63385079</span>
                    </p>
                    <p class="nav-list_item">
                        <img :src="emailIcon" />
                        <span>cbialijiayu@163.com</span>
                    </p> -->
                </div>
            </div>
            <div class="nav_part1-wx">
                <div class="nav-title">微信公众号</div>
                <img :src="serviceIcon" alt="" />
                <img :src="registerIcon" alt="" />
            </div>
        </div>
        <div class="footer-nav_part2">
            <div class="nav-sub_title">友情链接</div>
            <div class="nav_part2-list">
                <div class="part2-list_item"><a href="https://www.miit.gov.cn/">中国人民共和国工业和信息化部</a></div>
                <div class="part2-list_item"><a href="http://www.caict.ac.cn/">中国信息通信研究院</a></div>
                <div class="part2-list_item"><a href="https://www.idfactory.cn/">中国工业互联网顶级节点</a></div>
            </div>
        </div>
        <div class="text-wrapper_11">
      <span class="text_42">Copyright © 2023 &nbsp; &nbsp; 南京复创智能制造技术有限责任公司 |
        <span class="copyright_active"
              @click="convertLoad('https://beian.miit.gov.cn/')">苏ICP备2022027126号-7</span></span>
        </div>
    </div>
</template>
<script>
import locationIcon from '@/assets/images/footerNav/mobile/location-icon.png';
import phoneIcon from '@/assets/images/footerNav/mobile/phone-icon.png';
import emailIcon from '@/assets/images/footerNav/mobile/email-icon.png';
import qrcodeImg from '@/assets/images/footerNav/mobile/qrcode-img.png';
import czjIcon from "@/assets/images/footerNav/czj_icon.png";
import serviceIcon from "@/assets/images/home/serviceQrcode.png";
import registerIcon from "@/assets/images/home/registerQrcode.png";
export default {
    name: 'mobileFooterNav',
    data() {
        return {
            locationIcon,
            phoneIcon,
            emailIcon,
            czjIcon,
            qrcodeImg,
            serviceIcon,
            registerIcon
        }
    },
    methods: {
        convertLoad(url) {
            window.open(url);
        },
    }
}
</script>
<style lang="less" scoped>
@import url("./index.less");
.text-wrapper_11 {
    padding: 0px 24px 8px;
    word-wrap: break-word;
    text-align: center;
    color: #1c1c026b;
}
</style>
